import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { PageSection } from '@openx/components-core/lib/PageSection/PageSection.tsx';
import { trackCreateDealConversion } from '@openx/utils/lib/googleAnalytics.ts';
import type { JSX } from 'react';
import { useDealActivationModal } from '../../../components/DealActivationModal/useDealActivationModal.tsx';
import { Tags } from '../../../components/Tags/Tags.tsx';
import type { DealDetailsProps } from '../../../types/index.ts';
import { GreenDeal } from '../components/GreenDeal.tsx';
import { StyledButtonContainerGrid, StyledContainerGrid } from './styledComponents/DealDetailsSetion.styled.tsx';
import { StyledDetailSectionContainer } from './styledComponents/StyledDetailSectionContainer.tsx';

export const DealDetailsSection = ({ deal }: DealDetailsProps): JSX.Element => {
  const { openDealActivationModal } = useDealActivationModal();
  const matchesWidth = useMediaQuery('(max-width: 760px)');

  const gridItemWidth = matchesWidth ? 8 : 6;

  return (
    <StyledDetailSectionContainer>
      <PageSection divider title="Deal Details">
        <Grid size={gridItemWidth}>
          {deal.isGreen && <GreenDeal />}

          <StyledContainerGrid container spacing={4}>
            {deal.monthlyRequests && (
              <Grid size={gridItemWidth}>
                <FieldDetails title={'Monthly Requests'} value={deal.monthlyRequests.toLocaleString()} />
              </Grid>
            )}
            {deal.uniqueUsers && (
              <Grid size={gridItemWidth}>
                <FieldDetails title={'Unique Users'} value={deal.uniqueUsers.toLocaleString()} />
              </Grid>
            )}
          </StyledContainerGrid>

          {deal.description && <FieldDetails title={'Deal Description'} value={deal.description} />}

          <Grid container>
            {deal.tags && deal.tags.length > 0 && (
              <Grid size={12}>
                <Tags
                  tags={deal.tags}
                  handleTagClick={() => {
                    /* intentionally left blank */
                  }}
                />
              </Grid>
            )}

            <StyledButtonContainerGrid size={12}>
              <Button
                variant="contained"
                data-test="create-deal-button"
                onClick={() => {
                  trackCreateDealConversion();
                  openDealActivationModal(deal.name);
                }}
              >
                Create Deal
              </Button>
            </StyledButtonContainerGrid>
          </Grid>
        </Grid>
      </PageSection>
    </StyledDetailSectionContainer>
  );
};
